/**
 * abilityVfxSkirmisher — Yasuo / Riven / Irelia silhouettes (SPY-812).
 */

function mat(THREE, color, opacity = 0.9) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: opacity < 1,
    opacity,
    side: THREE.DoubleSide
  });
}

export function buildSteelTempest(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1);
  const blade = mat(THREE, spec.color || 0x93c5fd);
  const mesh = new THREE.Mesh(new THREE.BoxGeometry(0.5 * s, 0.06 * s, 0.14 * s), blade);
  mesh.position.y = 0.45 * s;
  group.add(mesh);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.1 * s, 0.28 * s, 4).rotateX(Math.PI / 2), blade);
  tip.position.set(0.32 * s, 0.45 * s, 0);
  group.add(tip);
  group.userData = { shape: 'steel_tempest' };
  return group;
}

export function buildWindWall(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.2);
  const wall = mat(THREE, spec.color || 0xbae6fd, 0.7);
  const panel = new THREE.Mesh(new THREE.BoxGeometry(1.2 * s, 1.0 * s, 0.08 * s), wall);
  panel.position.y = 0.55 * s;
  group.add(panel);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.3 * s, 0.5 * s, 16).rotateX(-Math.PI / 2),
    mat(THREE, 0xe0f2fe, 0.55)
  );
  ring.position.y = 0.05;
  group.add(ring);
  group.userData = { shape: 'wind_wall' };
  return group;
}

export function buildSweepingBlade(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.1);
  const dash = mat(THREE, spec.color || 0x60a5fa, 0.85);
  const trail = new THREE.Mesh(new THREE.CylinderGeometry(0.08 * s, 0.18 * s, 0.9 * s, 8), dash);
  trail.rotation.z = Math.PI / 2;
  trail.position.y = 0.4 * s;
  group.add(trail);
  group.userData = { shape: 'sweeping_blade' };
  return group;
}

export function buildLastBreath(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.8 * (spec.scale || 1.4);
  const storm = mat(THREE, spec.color || 0x38bdf8);
  const funnel = new THREE.Mesh(new THREE.ConeGeometry(0.35 * s, 1.1 * s, 8), storm);
  funnel.position.y = 0.7 * s;
  group.add(funnel);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.25 * s, 0.55 * s, 12).rotateX(-Math.PI / 2),
    mat(THREE, 0x7dd3fc, 0.75)
  );
  ring.position.y = 0.08;
  group.add(ring);
  group.userData = { shape: 'last_breath' };
  return group;
}

export function buildBrokenWings(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.2);
  const slash = mat(THREE, spec.color || 0xa78bfa, 0.88);
  const arc = new THREE.Mesh(new THREE.BoxGeometry(0.9 * s, 0.05 * s, 0.2 * s), slash);
  arc.position.y = 0.5 * s;
  group.add(arc);
  const wing = new THREE.Mesh(new THREE.ConeGeometry(0.2 * s, 0.45 * s, 4), slash);
  wing.position.set(0.35 * s, 0.55 * s, 0);
  group.add(wing);
  group.userData = { shape: 'broken_wings' };
  return group;
}

export function buildKiBurst(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.15);
  const burst = mat(THREE, spec.color || 0xc4b5fd, 0.8);
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.28 * s, 10, 10), burst);
  core.position.y = 0.45 * s;
  group.add(core);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.35 * s, 0.6 * s, 16).rotateX(-Math.PI / 2),
    mat(THREE, 0xddd6fe, 0.7)
  );
  ring.position.y = 0.05;
  group.add(ring);
  group.userData = { shape: 'ki_burst' };
  return group;
}

export function buildValor(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.2);
  const shield = mat(THREE, spec.color || 0xe9d5ff, 0.75);
  const disc = new THREE.Mesh(
    new THREE.CylinderGeometry(0.45 * s, 0.45 * s, 0.08 * s, 16),
    shield
  );
  disc.position.y = 0.5 * s;
  group.add(disc);
  const rim = new THREE.Mesh(
    new THREE.RingGeometry(0.4 * s, 0.55 * s, 16).rotateX(-Math.PI / 2),
    mat(THREE, 0xf5f3ff, 0.65)
  );
  rim.position.y = 0.08;
  group.add(rim);
  group.userData = { shape: 'valor' };
  return group;
}

export function buildBladeOfTheExile(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.75 * (spec.scale || 1.35);
  const blade = mat(THREE, spec.color || 0x8b5cf6);
  const great = new THREE.Mesh(new THREE.BoxGeometry(0.18 * s, 1.2 * s, 0.08 * s), blade);
  great.position.y = 0.7 * s;
  group.add(great);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.3 * s, 4), blade);
  tip.position.y = 1.4 * s;
  group.add(tip);
  group.userData = { shape: 'blade_of_the_exile' };
  return group;
}

export function buildBladesurge(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.6 * (spec.scale || 1.05);
  const dash = mat(THREE, spec.color || 0xf472b6, 0.85);
  const blade = new THREE.Mesh(new THREE.ConeGeometry(0.12 * s, 0.55 * s, 5).rotateX(Math.PI / 2), dash);
  blade.position.y = 0.4 * s;
  group.add(blade);
  const spark = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), dash);
  spark.position.set(0.25 * s, 0.4 * s, 0);
  group.add(spark);
  group.userData = { shape: 'bladesurge' };
  return group;
}

export function buildDefiantDance(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.7 * (spec.scale || 1.2);
  const dance = mat(THREE, spec.color || 0xfb7185, 0.78);
  const body = new THREE.Mesh(new THREE.CylinderGeometry(0.25 * s, 0.32 * s, 0.9 * s, 10), dance);
  body.position.y = 0.5 * s;
  group.add(body);
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(0.3 * s, 0.55 * s, 16).rotateX(-Math.PI / 2),
    mat(THREE, 0xfda4af, 0.65)
  );
  ring.position.y = 0.05;
  group.add(ring);
  group.userData = { shape: 'defiant_dance' };
  return group;
}

export function buildFlawlessDuet(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.65 * (spec.scale || 1.1);
  const blade = mat(THREE, spec.color || 0xf43f5e);
  const a = new THREE.Mesh(new THREE.BoxGeometry(0.35 * s, 0.05 * s, 0.1 * s), blade);
  a.position.set(-0.2 * s, 0.45 * s, 0);
  group.add(a);
  const b = new THREE.Mesh(new THREE.BoxGeometry(0.35 * s, 0.05 * s, 0.1 * s), blade);
  b.position.set(0.2 * s, 0.45 * s, 0);
  group.add(b);
  group.userData = { shape: 'flawless_duet' };
  return group;
}

export function buildVividBlade(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.75 * (spec.scale || 1.3);
  const vivid = mat(THREE, spec.color || 0xe11d48);
  const beam = new THREE.Mesh(new THREE.CylinderGeometry(0.1 * s, 0.16 * s, 1.2 * s, 8), vivid);
  beam.rotation.z = Math.PI / 2;
  beam.position.y = 0.5 * s;
  group.add(beam);
  const core = new THREE.Mesh(new THREE.SphereGeometry(0.18 * s, 10, 10), vivid);
  core.position.y = 0.5 * s;
  group.add(core);
  group.userData = { shape: 'vivid_blade' };
  return group;
}
